{
  "it": {
    "actions": {
      "admin": {
        "dashboard": {
          "reloadModels": "Ricarica modelli",
          "reloadScData": "Ricarica dati SC",
          "reloadPaints": "Ricarica verniciature",
          "reloadModules": "Ricarica moduli",
          "reloadLoaners": "Ricarica navi in comodato"
        },
        "supporterContributions": {
          "syncFromPatreon": "Sincronizza da Patreon"
        },
        "imports": {
          "cleanup": "Segna come fallita",
          "cleanupSelected": "Segna la selezione come fallita"
        }
      },
      "duplicate": "Duplica",
      "upgrade": "Aggiornamento disponibile!",
      "backToHome": "Pianifica nuova rotta",
      "disableGrouping": "Disabilita raggruppamento",
      "enableGrouping": "Abilita raggruppamento",
      "groupedByModel": "Raggruppa per modello",
      "destroyAccount": "Elimina Account",
      "saveScreenshot": "Salva come PNG",
      "resolve": "Risolvi",
      "sortBy": "Ordina per",
      "back": "Indietro",
      "open": "Apri",
      "copy": "Copia",
      "download": "Scarica",
      "zoom": "Zoom",
      "more": "Di più...",
      "export": "Esporta",
      "exportHangarLink": "Esporta per hangar.link",
      "import": "Importa",
      "here": "qui",
      "previous": "Precedente",
      "next": "Successivo",
      "cancel": "Annulla",
      "ok": "Ok",
      "reset": "Reset",
      "reload": "Ricarica",
      "confirm": "Conferma",
      "showDetailPage": "Pagina dei dettagli",
      "showDetails": "Mostra i dettagli",
      "hideDetails": "Nascondi i dettagli",
      "showGuide": "Mostra guida",
      "showFleetchart": "Grafico flotta",
      "hideFleetchart": "Vista di default",
      "fleetchartApp": {
        "useExtendedState": "Mostra le navi in configurazione estesa",
        "useRetractedState": "Mostra le navi in configurazione retratta"
      },
      "showLabels": "Mostra etichette",
      "hideLabels": "Nascondi etichette",
      "resetZoom": "Resetta lo zoom",
      "supportUs": "Supporta FleetYards.net",
      "supportHint": {
        "cta": "Supporta FleetYards",
        "later": "Forse più tardi"
      },
      "login": "Accedi",
      "signUp": "Registrati",
      "confirmAccess": "Conferma la password",
      "sendConfirmAccessEmail": "Invia e-mail di conferma",
      "reset-password": "Password dimenticata?",
      "edit": "Modifica",
      "clear": "Cancella",
      "done": "Conferma",
      "share": "Condividi",
      "change": "Cambia",
      "upload": "Carica",
      "save": "Salva",
      "enable": "Attiva",
      "disable": "Disattiva",
      "manage": "Gestisci",
      "enableGlobally": "Attiva globalmente",
      "disableGlobally": "Disattiva globalmente",
      "addActor": "Aggiungi attore",
      "addGroup": "Aggiungi gruppo",
      "editGroup": "Modifica gruppo",
      "remove": "Rimuovi",
      "reorder": "Riordina",
      "delete": "Elimina",
      "deleteSelected": "Elimina selezionati",
      "enableSelected": "Attiva selezionati",
      "disableSelected": "Disattiva selezionati",
      "close": "Chiudi",
      "filter": "Filtra",
      "showStatusColor": "Mostra stato come colori",
      "hideStatusColor": "Nascondi stato come colori",
      "addToHangar": "Aggiungi all'hangar",
      "resetFilter": "Resetta i filtri",
      "requestPassword": "Richiedi la password via email",
      "changePassword": "Cambia la password",
      "updatePassword": "Aggiorna la password",
      "copyBackupCodes": "Copia i codici di backup",
      "regenerate": "Rigenera",
      "add": "Aggiungi",
      "create": "Crea",
      "addToWishlist": "Aggiungi alla lista dei desideri",
      "addVehicle": "Aggiungi nave",
      "showTableView": "Mostra come lista",
      "showGridView": "Mostra come griglia",
      "linkExisting": "Collega esistente",
      "loadMore": "Carica altro",
      "unlink": "Scollega",
      "syncRsiHangar": "Sincronizza hangar RSI",
      "oauthApplications": {
        "create": "Nuova applicazione",
        "regenerateSecret": "Rigenera segreto",
        "approve": "Approva",
        "reject": "Rifiuta",
        "rejectSelected": "Rifiuta selezionate"
      },
      "oauthAuthorize": {
        "authorize": "Autorizza",
        "deny": "Rifiuta"
      },
      "verifyWithCitizenId": "Verifica con Citizen iD",
      "oauth": {
        "signInWith": "Accedi con",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Connesso a Google",
          "discord": "Connesso a Discord",
          "bluesky": "Connesso a BlueSky",
          "github": "Connesso a GitHub",
          "twitch": "Connesso a Twitch",
          "citizenid": "Connesso a Citizen iD"
        },
        "disconnect": {
          "google": "Disconnetti Google",
          "discord": "Disconnetti Discord",
          "bluesky": "Disconnetti BlueSky",
          "github": "Disconnetti GitHub",
          "twitch": "Disconnetti Twitch",
          "citizenid": "Disconnetti Citizen iD"
        }
      },
      "compare": {
        "ships": "Compara"
      },
      "cargoGrids": {
        "addShips": "Aggiungi navi"
      },
      "hangar": {
        "editGroups": "Aggiungi o rimuovi gruppo",
        "editName": "Rinomina la nave",
        "manageLoadouts": "Gestisci configurazioni",
        "manageCargo": "Gestisci carico",
        "useName": "Usa il nome",
        "destroyAll": "Rimuovi tutte le navi",
        "showOnPublicHangar": "Rendi pubblico",
        "hideFromPublicHangar": "Nascondi da pubblico",
        "editGroupsSelected": "Aggiungi/rimuovi gruppo",
        "resetIngame": {
          "openModal": "Resetta navi in-game dopo il wipe",
          "moveToWishlist": "Sposta nella lista dei desideri",
          "removeAll": "Rimuovi tutto"
        }
      },
      "syncExtension": {
        "cancel": "Annulla",
        "start": "Avvia sincronizzazione",
        "retry": "Riprova sincronizzazione",
        "close": "Chiudi",
        "refresh": "Aggiorna pagina"
      },
      "empty": {
        "hangarGuide": "Serve aiuto?",
        "reset": "Cancella filtri"
      },
      "destroyFleet": "Distruggi flotta",
      "restore": "Ripristina",
      "fleet": {
        "join": "Unisciti a %{fleet}!",
        "leave": "Abbandona %{fleet}",
        "createInviteUrl": "Crea Urls d'invito",
        "inviteMember": "Invita nuovi membri",
        "manageInvites": "Inviti",
        "worldmap": "Mappa mondiale",
        "starmap": "Mappa stellare",
        "acceptInvite": "Accetta l'invito",
        "declineInvite": "Rifiuta l'invito",
        "acceptRequest": "Accetta la richiesta",
        "declineRequest": "Rifiuta la richiesta",
        "members": {
          "invite": "Invita",
          "promote": "Promuovi",
          "demote": "Retrocedi",
          "accept": "Accetta",
          "decline": "Rifiuta",
          "remove": "Rimuovi",
          "editRole": "Modifica ruolo"
        },
        "inviteUrls": {
          "create": "Crea nuovo URL per invito"
        },
        "discord": {
          "test": "Prova la connessione Discord",
          "installBot": "Installa il bot Fleetyards nel tuo server Discord"
        },
        "calendarSubscription": {
          "enable": "Genera link di sottoscrizione",
          "rotate": "Rigenera il link",
          "disable": "Disattiva la sottoscrizione"
        }
      },
      "model": {
        "gallery": "Galleria",
        "onSale": "In vendita %{price}",
        "store": "Pagina su RSI"
      },
      "models": {
        "sync": "Sincronizza da RSI",
        "syncMatrix": "Sincronizza matrice",
        "syncScData": "Sincronizza dati SC",
        "importPaints": "Importa verniciature",
        "exchangeStoreImage": "Usa immagine RSI",
        "images": "Immagini",
        "openTableConfiguration": "Apri configurazione tabella"
      },
      "users": {
        "loginAs": "Accedi come utente",
        "resendConfirmation": "Reinvia conferma",
        "sendPasswordReset": "Invia reset password"
      },
      "unselect": "Deseleziona tutti i selezionati",
      "twoFactor": {
        "enable": "Abilita Due Fattori",
        "disable": "Disabilita Due-Fattori",
        "generateBackupCodes": "Genera Codici Di Backup"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Abilita rotazione automatica",
          "disable": "Disabilita rotazione automatica"
        },
        "zoom": {
          "enable": "Abilita zoom",
          "disable": "Disabilita zoom"
        },
        "color": {
          "enable": "Abilita i colori",
          "disable": "Disabilita i colori"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "Svuota carico",
        "viewCargoGrid": "Vedi griglia di carico"
      },
      "adminNotifications": {
        "unread": "Segna come non letta",
        "archive": "Archivia",
        "unarchive": "Riporta in arrivo",
        "readAll": "Segna tutte come lette",
        "destroyAll": "Elimina tutte",
        "sortOldest": "Prima le più vecchie",
        "sortNewest": "Prima le più recenti",
        "select": "Seleziona notifica",
        "readSelected": "Segna le selezionate come lette",
        "unreadSelected": "Segna le selezionate come non lette",
        "archiveSelected": "Archivia le selezionate",
        "unarchiveSelected": "Riporta in arrivo le selezionate",
        "destroySelected": "Elimina le selezionate"
      },
      "account": {
        "calendarSubscription": {
          "enable": "Genera link calendario personale",
          "rotate": "Rigenera il link",
          "disable": "Disattiva la sottoscrizione"
        }
      },
      "today": "Oggi",
      "fleets": {
        "missions": {
          "create": "Crea missione",
          "edit": "Modifica missione",
          "archive": "Archivia missione",
          "unarchive": "Ripristina",
          "destroy": "Elimina definitivamente",
          "addTeam": "Aggiungi team",
          "addShip": "Aggiungi nave",
          "addSlot": "Aggiungi slot",
          "viewMissions": "Vedi le missioni"
        },
        "events": {
          "create": "Crea evento",
          "edit": "Modifica evento",
          "spawn": "Genera da questa missione",
          "archive": "Archivia evento",
          "unarchive": "Ripristina dall'archivio",
          "syncToDiscord": "Sincronizza su Discord",
          "destroy": "Elimina definitivamente",
          "publish": "Pubblica",
          "lockSignups": "Blocca le iscrizioni",
          "unlockSignups": "Sblocca le iscrizioni",
          "start": "Avvia",
          "complete": "Completa",
          "cancel": "Annulla",
          "signup": "Iscriviti",
          "withdraw": "Ritirati",
          "kick": "Rimuovi iscrizione",
          "addToCalendar": "Aggiungi al calendario",
          "subscribe": "Sottoscrivi",
          "setUpCalendar": "Configura le sottoscrizioni al calendario",
          "assignSlot": "Assegna a uno slot",
          "reassignSlot": "Sposta in un altro slot",
          "addSeats": "Aggiungi posti",
          "manageEventTeam": "Gestisci il team dell'evento",
          "grantRole": "Assegna ruolo",
          "revokeRole": "Revoca",
          "addTeam": "Aggiungi team"
        }
      },
      "notifications": {
        "unread": "Segna come non letta",
        "archive": "Archivia",
        "unarchive": "Riporta in arrivo",
        "readAll": "Segna tutte come lette",
        "destroyAll": "Elimina tutte",
        "settings": "Impostazioni notifiche",
        "sortOldest": "Prima le più vecchie",
        "sortNewest": "Prima le più recenti",
        "openCenter": "Notifiche",
        "select": "Seleziona notifica",
        "readSelected": "Segna le selezionate come lette",
        "unreadSelected": "Segna le selezionate come non lette",
        "archiveSelected": "Archivia le selezionate",
        "unarchiveSelected": "Riporta in arrivo le selezionate",
        "destroySelected": "Elimina le selezionate"
      },
      "unlistedModel": {
        "createModel": "Crea nave",
        "markAsPaint": "È una livrea",
        "ignore": "Ignora",
        "noManufacturer": "Nessun produttore corrisponde a questo identificatore",
        "alreadyExists": "%{name} è già nel catalogo",
        "link": "Già nel catalogo",
        "markAsPaintSelected": "Segna la selezione come livree",
        "ignoreSelected": "Ignora la selezione"
      },
      "revert": "Ripristina",
      "exportCsv": "Esporta CSV",
      "exportAllCsv": "Esporta tutto in CSV"
    }
  }
}
